module.exports = __webpack_public_path__ + "img/function_default.604ac9d6.png";